module.exports = __webpack_public_path__ + "img/app-code.21548545.png";